// Display faces loaded from Google Fonts in index.html. Inline styles keep the
// serif headings on the landing and login pages out of the utility layer.
export const DISPLAY_SERIF = { fontFamily: "'Playfair Display', Georgia, serif" };
export const DISPLAY_CAPS = { fontFamily: 'Cinzel, Georgia, serif' };
